// import WelcomeToCustomers from '@features/customers/components/WelcomeToCustomers';
import useSearch from '@features/customers/hooks/search.hook';
import ContainerProps from '@interfaces/container.interface';
import { Grid } from '@mui/material';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBar from '../../components/SearchBar';
import useCustomersContainerStyles from './BusinessGroupsContainer.styles';
import { parse as queryString } from 'query-string';
import SearchFilters from '@features/customers/constants/search-filters.enum';
import { CUSTOMERS_PATH } from '@constants/paths.constant';
import BusinessGroups from '@features/customers/components/BusinessGroups';

const BusinessGroupsContainer: React.FC<ContainerProps> = ({ menuState }) => {
	// Hooks
	const classes = useCustomersContainerStyles();
	const location = useLocation();
	const navigate = useNavigate();
	const search = useSearch();

	// Effects
	useEffect(() => {
		try {
			if (location.search && location.search.length > 0) {
				const {
					division: queryDivision,
					filter: queryFilter,
					search: querySearch,
				} = queryString(location.search);

				if (typeof queryFilter === 'string' && typeof querySearch === 'string') {
					const realFilter = Object.entries(SearchFilters).find(
						([, value]) => value === queryFilter
					);

					if (!realFilter) {
						navigate(CUSTOMERS_PATH);
						throw new Error('El filtro proveniente de la query no es válido.');
					}

					if (!search.verifyText(querySearch, realFilter[1])) {
						navigate(CUSTOMERS_PATH);
						throw new Error(
							'El texto de búsqueda proveniente de la query no es válido.'
						);
					}

					if (search.text.toLowerCase() === querySearch.toLowerCase()) {
						return;
					}

					search.handleSearchPressed(undefined, querySearch, realFilter[1]);

					if (typeof queryDivision === 'string') {
						search.setDivisionNumber(queryDivision);
					} else {
						search.setDivisionNumber('');
					}
				}
			} else if (search.data || search.text.length > 0) {
				search.reset();
			}
		} catch (e) {
			console.error('Location search', e);

			if (search.data || search.text.length > 0) {
				search.reset();
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);

	useEffect(() => {
		document?.getElementById('gestionar_clientes_')?.addEventListener(
			'click',
			() => {
				search.reset();
			},
			false
		);
	}, [search]);

	return (
		<Grid container id="customers-container">
			<Grid item xs={12}>
				<div
					className={clsx(classes.headerContainer, {
						[classes.headerContainerBig]: menuState === 'big',
						[classes.headerContainerSmall]: menuState === 'small',
					})}
				>
					<SearchBar
						handleChangeFilter={search.handleChangeFilter}
						data={search.autocompleteData}
						filter={search.filter}
						handleAutocompleteSearch={search.handleAutocompleteSearch}
						handleSearchPressed={search.handleSearchPressed}
						loading={search.autocompleteLoading}
						needAutocomplete={search.needAutocomplete}
						searchText={search.autocompleteText}
						setNeedAutocomplete={search.setNeedAutocomplete}
						verifyText={search.verifyText}
						setValueEmail={search.setValueEmail}
						valueEmail={search.valueEmail}
					/>
				</div>
			</Grid>
			<Grid item xs={12}>
				<div className={classes.elementContainer}>
					{/* {!search.pressed && <WelcomeToCustomers />} */}
					{/* {search.pressed && <div>Hola mundo</div>} */}
					<BusinessGroups />
				</div>
			</Grid>
		</Grid>
	);
};

export default BusinessGroupsContainer;
